import { render } from "./tender_info.vue?vue&type=template&id=fcbfcee4"
import script from "./tender_info.vue?vue&type=script&lang=js"
export * from "./tender_info.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/tender/inside/tabs/tender_info.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fcbfcee4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fcbfcee4', __exports__)) {
    console.log('reload')
    api.reload('fcbfcee4', __exports__)
  }
  
  module.hot.accept("./tender_info.vue?vue&type=template&id=fcbfcee4", () => {
    console.log('re-render')
    api.rerender('fcbfcee4', render)
  })

}


export default __exports__